export default __webpack_public_path__ + "static/media/about.5342ef52.svg";